import React, { useState, useEffect } from "react";
import Content from "../../../layout/content/Content";
import Head from "../../../layout/head/Head";
import DatePicker from "react-datepicker";
import {
    UncontrolledDropdown,
    DropdownMenu,
    DropdownToggle,
    Card,
    FormGroup,
    Modal,
    ModalBody,
    DropdownItem,
    Form,
    Badge,
    Spinner,
} from "reactstrap";
import {
    Button,
    Block,
    BlockBetween,
    BlockDes,
    BlockHead,
    BlockHeadContent,
    BlockTitle,
    Icon,
    Col,
    PaginationComponent,
    Row,
    RSelect,
    UserAvatar,
    OverlineTitle,
    PreviewCard,
} from "../../../components/Component";

import { dateFormatterAlt } from "../../../utils/Utils";
import { useForm } from "react-hook-form";
import Swal from "sweetalert2";

const AddDetail = (props) => {
    const [loading, setLoading] = useState(false);
    const [transData, setTransData] = useState([]);
    const [onSearch, setonSearch] = useState(true);
    const [onSearchText, setSearchText] = useState("");
    const [modal, setModal] = useState({
        add: false,
    });
    const [viewModal, setViewModal] = useState(false);
    const [detail, setDetail] = useState({});

    const [data, setData] = useState(transData);
    const [formData, setFormData] = useState({
        catType: "",



    });
    const [currentPage, setCurrentPage] = useState(1);
    const [itemPerPage, setItemPerPage] = useState(10);
    const [sort, setSortState] = useState("");

    const getdata = async () => {
        const sendData = {

            CatgId: Number(sessionStorage.getItem('catid')),
            Value: sessionStorage.getItem('value') === "null" ? null : Number(sessionStorage.getItem('value')),
        }
        await fetch('https://n4nairmatrimonyapi.azurewebsites.net/api/Data/GetDetailsofcat', {
            method: 'POST',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json'
            },
            body: JSON.stringify(sendData)

        })
            .then(response => response.json())
            .then(
                data => {
                    setTransData(data)
                    setData(data)
                })


    };

    const onInputChange = (e) => {
        setFormData({ ...formData, [e.target.name]: e.target.value });
    };

    const sortingFunc = (params) => {
        let defaultData = data;
        if (params === "asc") {
            let sortedData = [...defaultData].sort((a, b) => parseFloat(a.cloudMcatId) - parseFloat(b.cloudMcatId));
            setData([...sortedData]);
        } else if (params === "dsc") {
            let sortedData = [...defaultData].sort((a, b) => parseFloat(b.cloudMcatId) - parseFloat(a.cloudMcatId));
            setData([...sortedData]);
        }
    };

    // Changing state value when searching name
    useEffect(() => {
        if (onSearchText !== "") {
            const filteredObject = transData.filter((item) => {
                return item.catgType.toLowerCase().includes(onSearchText.toLowerCase());
            });
            setData([...filteredObject]);
        }
        else {
            setData([...transData]);
        }

    }, [onSearchText]);


    useEffect(() => {
        getdata()
    }, [])

    // onChange function for searching name
    const onFilterChange = (e) => {
        setSearchText(e.target.value);
    };

    // function to reset the form
    const resetForm = () => {
        setFormData({
            catType: "",

        });
    };

    // function to close the form modal
    const onFormCancel = () => {
        setModal({ add: false });
        resetForm();
    };

    // submit function to add a new item
    /*const onFormSubmit = (submitData) => {
        
        

        ////console.log(submitData)
        setModal({ add: false });
    };*/

    const onFormSubmit = async (catgTypeId) => {

        Swal.fire({
            title: 'Are You Sure ?',
            icon: 'question',
            showDenyButton: true,
            showCancelButton: false,
            confirmButtonText: 'Delete',
            confirmButtonColor: 'success',
            denyButtonText: `Cancel`,
        }).then(async (result) => {

            /* Read more about isConfirmed, isDenied below */
            let timerInterval
            if (result.isConfirmed) {
                Swal.fire({
                    title: 'Updating....',
                    html: 'I will close in <b></b> milliseconds.',
                    timer: 20000,
                    timerProgressBar: true,
                    didOpen: () => {
                        Swal.showLoading()
                        const b = Swal.getHtmlContainer().querySelector('b')
                        timerInterval = setInterval(() => {
                            b.textContent = Swal.getTimerLeft()
                        }, 100)
                    },
                    willClose: () => {
                        clearInterval(timerInterval)
                    }
                })
                const sendData = {
                    CatgTypeId: catgTypeId,

                }
                await fetch('https://n4nairmatrimonyapi.azurewebsites.net/api/Data/DeleteCat', {
                    method: 'POST',
                    headers: {
                        'Accept': 'application/json',
                        'Content-Type': 'application/json'
                    },
                    body: JSON.stringify(sendData)

                })
                    .then(response => response.json())
                    .then(
                        data => {
                            setLoading(false)
                            onFormCancel()
                            if (data === "Done") {
                                Swal.fire({
                                    icon: "success",
                                    title: "Done",
                                    text: "Deleted Successfully",
                                    focusConfirm: false,
                                });
                                getdata()



                            }
                            else {
                                Swal.fire({
                                    icon: "error",
                                    title: "Error",
                                    text: "Not Deleted",
                                    focusConfirm: false,
                                });
                                getdata()
                            }
                        })

            } else if (result.isDenied) {
                getdata()
            }
        })



    };


    const onFormSubmit2 = async (data) => {

        /*////console.log(data)*/

        /*setLoading(true)*/


        const sendData = {
            CatgId: Number(sessionStorage.getItem('catid')),
            CatgType: formData.catType,
            CatgDesc: formData.catType,
            Value: sessionStorage.getItem('value') === "null" ? null : Number(sessionStorage.getItem('value')),
        }


        await fetch('https://n4nairmatrimonyapi.azurewebsites.net/api/Data/AddCat', {
            method: 'POST',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json'
            },
            body: JSON.stringify(sendData)

        })
            .then(response => response.json())
            .then(
                data => {
                    /*setLoading(false)*/
                    onFormCancel()
                    if (data === "Done") {
                        Swal.fire({
                            icon: "success",
                            title: "Done",
                            text: "Added Option Successfully",
                            focusConfirm: false,
                        });
                        getdata()


                    }
                    else {
                        Swal.fire({
                            icon: "error",
                            title: "Error",
                            text: "Not Added",
                            focusConfirm: false,
                        });
                        getdata()
                    }
                })


    };

    // function to load detail data
    const loadDetail = (id) => {
        let index = data.findIndex((item) => item.id === id);
        setDetail(data[index]);
    };

    // function to toggle the search option
    const toggle = () => setonSearch(!onSearch);

    // Get current list, pagination
    const indexOfLastItem = currentPage * itemPerPage;
    const indexOfFirstItem = indexOfLastItem - itemPerPage;
    const currentItems = data.slice(indexOfFirstItem, indexOfLastItem);

    // Change Page
    const paginate = (pageNumber) => setCurrentPage(pageNumber);

    const { errors, register, handleSubmit } = useForm();

    return (
        <React.Fragment>

            <Content>
                <BlockHead size="sm">

                    <BlockDes className="text-soft">
                        <h2>Edit {sessionStorage.getItem('dropdownname')} Option</h2>
                        <Button onClick={() => props.history.goBack()} color="dark"><Icon name="arrow-left" /> BACK</Button>
                    </BlockDes>


                </BlockHead>

                <Block>

                    <Card className="card-bordered card-stretch">
                        <div className="card-inner-group">
                            <div className="card-inner">
                                <div className="card-title-group">
                                    <Button color="primary" className="btn-icon" onClick={() => setModal({ add: true })}>
                                        <Icon name="plus"></Icon> <p style={{ marginRight: 10, color: "white" }}> Add New</p>
                                    </Button>
                                    <div className="card-tools mr-n1">
                                        <ul className="btn-toolbar">

                                            <li>
                                                <Button onClick={toggle} className="btn-icon search-toggle toggle-search">
                                                    <Icon name="search"></Icon>
                                                </Button>
                                            </li>
                                            <li className="btn-toolbar-sep"></li>
                                            <li>
                                                <UncontrolledDropdown>
                                                    <DropdownToggle tag="a" className="dropdown-toggle btn btn-icon btn-trigger">
                                                        <Icon name="setting"></Icon>
                                                    </DropdownToggle>
                                                    <DropdownMenu right>
                                                        <ul className="link-check">
                                                            <li>
                                                                <span>Show</span>
                                                            </li>
                                                            <li className={itemPerPage === 5 ? "active" : ""}>
                                                                <DropdownItem
                                                                    tag="a"
                                                                    href="#dropdownitem"
                                                                    onClick={(ev) => {
                                                                        ev.preventDefault();
                                                                        setItemPerPage(5);
                                                                    }}
                                                                >
                                                                    5
                                                                </DropdownItem>
                                                            </li>
                                                            <li className={itemPerPage === 10 ? "active" : ""}>
                                                                <DropdownItem
                                                                    tag="a"
                                                                    href="#dropdownitem"
                                                                    onClick={(ev) => {
                                                                        ev.preventDefault();
                                                                        setItemPerPage(10);
                                                                    }}
                                                                >
                                                                    10
                                                                </DropdownItem>
                                                            </li>
                                                        </ul>
                                                        <ul className="link-check">
                                                            <li>
                                                                <span>Order</span>
                                                            </li>
                                                            <li className={sort === "dsc" ? "active" : ""}>
                                                                <DropdownItem
                                                                    tag="a"
                                                                    href="#dropdownitem"
                                                                    onClick={(ev) => {
                                                                        ev.preventDefault();
                                                                        setSortState("dsc");
                                                                        sortingFunc("dsc");
                                                                    }}
                                                                >
                                                                    DESC
                                                                </DropdownItem>
                                                            </li>
                                                            <li className={sort === "asc" ? "active" : ""}>
                                                                <DropdownItem
                                                                    tag="a"
                                                                    href="#dropdownitem"
                                                                    onClick={(ev) => {
                                                                        ev.preventDefault();
                                                                        setSortState("asc");
                                                                        sortingFunc("asc");
                                                                    }}
                                                                >
                                                                    ASC
                                                                </DropdownItem>
                                                            </li>
                                                        </ul>
                                                    </DropdownMenu>
                                                </UncontrolledDropdown>
                                            </li>
                                        </ul>
                                    </div>
                                    <div className={`card-search search-wrap ${!onSearch ? "active" : ""}`}>
                                        <div className="search-content">
                                            <Button
                                                className="search-back btn-icon toggle-search"
                                                onClick={() => {
                                                    setSearchText("");
                                                    toggle();
                                                }}
                                            >
                                                <Icon name="arrow-left"></Icon>
                                            </Button>
                                            <input
                                                type="text"
                                                className="form-control border-transparent form-focus-none"
                                                placeholder="Search by Option Name"
                                                value={onSearchText}
                                                onChange={(e) => onFilterChange(e)}
                                            />
                                            <Button className="search-submit btn-icon">
                                                <Icon name="search"></Icon>
                                            </Button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="table-responsive">
                                <table className="table">
                                    <thead>
                                        <tr >

                                            <th >
                                                Option Name

                                            </th>
                                            <th >
                                                Region Status

                                            </th>
                                            <th >
                                                Delete Option

                                            </th>

                                        </tr>
                                    </thead>
                                    <tbody>
                                        {currentItems.length > 0
                                            ? currentItems.map((item) => {
                                                return (
                                                    <tr scope="row" key={item.cloudMcatId} >

                                                        <td>
                                                            {item.catgType}

                                                        </td>
                                                        <td>
                                                            <Button color="secondary" >Region Status</Button>
                                                        </td>

                                                        <td >

                                                            <Button color='danger' onClick={() => onFormSubmit(item.catgTypeId)}>Delete</Button>
                                                        </td>

                                                    </tr>
                                                );
                                            })
                                            : null}
                                    </tbody>
                                </table>
                            </div>
                            <div className="card-inner">
                                {currentItems.length > 0 ? (
                                    <PaginationComponent
                                        noDown
                                        itemPerPage={itemPerPage}
                                        totalItems={data.length}
                                        paginate={paginate}
                                        currentPage={currentPage}
                                    />
                                ) : (
                                    <div className="text-center">
                                        <Spinner color="dark" className="xl" />
                                    </div>
                                )}
                            </div>
                        </div>
                    </Card>
                </Block>

                <Modal isOpen={modal.add} toggle={() => setModal({ add: false })} className="modal-dialog-centered" size="lg">
                    <ModalBody>
                        <a
                            href="#cancel"
                            onClick={(ev) => {
                                ev.preventDefault();
                                onFormCancel();
                            }}
                            className="close"
                        >
                            <Icon name="cross-sm"></Icon>
                        </a>
                        <div className="p-2">
                            <h5 className="title">Add Details</h5>
                            <div className="mt-4">
                                <Form className="row gy-4 mt-4" onSubmit={handleSubmit(onFormSubmit2)}>
                                    <Col md="6">
                                        <FormGroup>
                                            <label className="form-label">Option Name</label>
                                            <input
                                                className="form-control"
                                                ref={register({ required: "This field is required" })}
                                                type="text"
                                                name="catType"
                                                defaultValue={formData.catType}
                                                onChange={(e) => onInputChange(e)}
                                                placeholder="Enter Option Name"
                                            />
                                            {errors.catType && <span className="invalid">{errors.catType.message}</span>}
                                        </FormGroup>
                                    </Col>


                                    <Col size="12">
                                        <ul className="align-center flex-wrap flex-sm-nowrap gx-4 gy-2">
                                            <li>
                                                <Button color="primary" size="md" type="submit">
                                                    {loading ? <Spinner size="sm" color="light" /> : <><Icon name="plus" /> Add    </>}
                                                </Button>
                                            </li>
                                            <li>
                                                <a
                                                    href="#cancel"
                                                    onClick={(ev) => {
                                                        ev.preventDefault();
                                                        onFormCancel();
                                                    }}
                                                    className="link link-light"
                                                >
                                                    Cancel
                                                </a>
                                            </li>
                                        </ul>
                                    </Col>
                                </Form>
                            </div>
                        </div>
                    </ModalBody>
                </Modal>

                <Modal isOpen={viewModal} toggle={() => setViewModal(false)} className="modal-dialog-centered" size="lg">
                    <ModalBody>
                        <a
                            href="#cancel"
                            onClick={(ev) => {
                                ev.preventDefault();
                                setViewModal(false);
                            }}
                            className="close"
                        >
                            <Icon name="cross-sm"></Icon>
                        </a>
                        <div className="nk-modal-head">
                            <h4 className="nk-modal-title title">
                                Education <small className="text-primary"></small>
                            </h4>
                        </div>
                        <div className="nk-tnx-details mt-sm-3">
                            <Row className="gy-3">
                                <Col lg={6}>
                                    <span className="sub-text">ID</span>
                                    <span className="caption-text">{detail.cloudMcatId}</span>
                                </Col>
                                <Col lg={6}>
                                    <span className="sub-text">COURSE </span>
                                    <span className="caption-text text-break">{detail.mainDesc}</span>
                                </Col>
                                <Col lg={6}>
                                    <span className="sub-text">INSTITUTE</span>
                                    <span className="caption-text">{detail.columRemarks}</span>
                                </Col>
                                <Col lg={6}>
                                    <span className="sub-text">PASSING YEAR</span>
                                    <span className="caption-text">{detail.oremarks}</span>
                                </Col>

                            </Row>
                        </div>
                    </ModalBody>
                </Modal>
            </Content>

        </React.Fragment>
    );
};

export default AddDetail;
